import { Button, Stack, styled } from '@mui/material';
import DistributionInfo from 'components/DistributionInfo';

export const StyledReleaseDummyImage = styled('img')(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('sm')]: { display: 'none' },
}));

export const StyledCtaButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  [theme.breakpoints.down('sm')]: { width: '100%' },
}));

export const StyledDistributionInfo = styled(DistributionInfo)(() => ({
  margin: 0,
}));

export const StyledLoadingContainer = styled(Stack)(({ theme }) => ({
  height: theme.spacing(60),
  justifyContent: 'center',
  alignItems: 'center',
}));
